import React, { useEffect, useState } from 'react'
import View from './View'
import Redux from './Redux'
import { withRouter } from 'react-router-dom'
import {
	conditionObj, actionObj, dataTypeNumList, dataTypeStringList, actionTypesList, selectedComparatorList,
	retriveconditionsData, retriveActionsData, constructConditionsData, constructActionsData
} from '../../packages/businessrule'
import { toast } from 'react-toastify';
import { Query, Builder, BasicConfig, Utils as QbUtils } from 'react-awesome-query-builder';

const Container = (props) => {

	const [state, setState] = useState({
		form: {
			queryBuilder: { "id": QbUtils.uuid(), "type": "group" },
			queryDatamodel: ''
		},
		article: '',
		isSubmitButton: true,
		conditionsUIList: [],
		actionsUIList: [],
		dataModelList: [],
		dataElementList: [],
		forms: false,
	});

	useEffect(() => {
		console.log("props.location ===", props.location);
		updateBusinessRuleState();
	}, [props.location])

	useEffect(() => {
		updateFormState();
		console.log("props.rules?.data===", props.rules?.data);
	}, [props.rules?.data, props.dataModels?.data])

	useEffect(() => {
		if (props.rules?.saveSuccess) {
			toast.success(props.rules?.data.message
				|| 'Businessrule saved successfully');
			// props.showAlert('Businessrule saved successfully', { id: "rule", variant: 'success', icon: 'bell' });
			props.history.push({ pathname: `/${props.match.params.appid}/page/ruleview/${props.rules?.data._id}` });
		}
		if (props.rules?.updateSuccess) {
			toast.success(props.rules?.data.message
				|| 'Businessrule updated successfully');
			// props.showAlert('Businessrule updated successfully', { id: "rule", variant: 'success', icon: 'bell' });
			props.history.push({ pathname: `/${props.match.params.appid}/page/ruleview/${props.rules?.data._id}` });
		}
	}, [props.rules?.saveSuccess, props.rules?.updateSuccess])

	const handleChange = (event) => {
		setState({
			...state, form: _.set({ ...state.form },
				event.target.name, event.target.type === 'checkbox'
				? event.target.checked
				: event.target.value)
		});
	};

	const updateBusinessRuleState = () => {
		const params = props.match.params;
		const { id, appid } = params;
		props.getDataModels(appid);
		if (!id || id === 'new') {
			props.newBusinessRule();
		}
		else {
			props.getBusinessRule({ ...props.match.params, businessRuleId: id });
			resetState();
		}
	};

	const updateFormState = () => {
		let conditionList = [], actionList = [];
		console.log("props.rules?.data======", props.rules?.data);
		console.log("props.rules?.data.ruleset======", props.rules?.data?.ruleset);
		if (props.rules?.data && props.dataModels?.data && props.rules?.data?.ruleset) {
			let conditionData = props.rules?.data.ruleset[0].rule_definition.conditions;
			if (conditionData.length > 0) {
				conditionList = retriveconditionsData(conditionData, props.dataModels);
			} else {
				conditionList.push(conditionObj());
			}
			let actionData = props.rules?.data.ruleset[0].rule_definition.actions;
			if (actionData && actionData.length > 0) {
				actionList = retriveActionsData(actionData, props.dataModels)
			} else {
				actionList.push(actionObj());
			}
			let updateObj = {}
			updateObj.form = { ...state.form, ...props.rules?.data }
			if (props.rules?.data && props.rules?.data.ruleset) {
				updateObj.conditionsUIList = conditionList;
				updateObj.actionsUIList = actionList;
			}
			console.log("updateObj=======", updateObj);
			setState({ ...state, ...updateObj });
		} else {
			console.log("adding condition/action", "state.conditionsUIList", state.conditionsUIList,
				"state.actionsUIList", state.actionsUIList);
			// if (state.conditionsUIList.length === 0) {
			// 	addConditions();
			// }
			// if (state.actionsUIList.length === 0) {
			// 	addActions();
			// }
			if (state.conditionsUIList.length === 0 || state.actionsUIList.length === 0) {
				let conditions = conditionObj()
				let actions = actionObj()
				setState({
					...state,
					conditionsUIList: [conditions, ...state.conditionsUIList],
					actionsUIList: [actions, ...state.actionsUIList]
				})
			}
		}
	};

	const handleChipChange = (event, name) => {
		setState({ ...state, form: _.set({ ...state.form }, name, event.target.value) });
	};

	const canBeSubmitted = () => {
		const { form } = state;
		// console.log("isBussinessRuleUpdated", isBussinessRuleUpdated);
		return (form && form.name && form.name.length > 0 && isBussinessRuleUpdated()
			&& state.isSubmitButton
		);
	}

	const isBussinessRuleUpdated = () => {
		let isUpdate = false
		if (!_.isEqual(props.rules?.data, state.form)) {
			return true;
		}
		if (props.rules?.data && props.rules?.data.ruleset) {
			let conditionData = props.rules?.data.ruleset[0].rule_definition.conditions;
			let conditionList = retriveconditionsData(conditionData, props.dataModels);
			if (!_.isEqual(conditionList, state.conditionsUIList)) {
				return true;
			}
			let actionData = props.rules?.data.ruleset[0].rule_definition.actions;
			let actionList = retriveActionsData(actionData, props.dataModels)
			if (!_.isEqual(actionList, state.actionsUIList)) {
				return true;
			}
			isUpdate = false;
		}
		return isUpdate;
	}

	const saveBusinessRuleData = () => {
		setState({ ...state, isSubmitButton: false });
		props.saveBusinessRule({ ...state.form, appId: props.match.params.appid });
	}


	const updateBusinessRuleData = () => {
		setState({ ...state, isSubmitButton: false });
		props.updateBusinessRule({ ...state.form, appId: props.match.params.appid });
	}

	const resetState = () => {
		setState({
			...state,
			article: '',
			form: props.rules?.data,
			conditionsUIList: [],
			actionsUIList: [],
			dataModelList: [],
			dataElementList: [],
			forms: false
		})
		addConditions();
		addActions();
	}

	const handleDataModelLeftChange = (event, index) => {
		let list = props.dataModels?.data
		let conditionData = state.conditionsUIList;
		for (let i = 0; i < list.length; i++) {
			if (list[i]._id === event.target.value) {
				conditionData[index].dataModelLeftSelected = event.target.value;
				conditionData[index].dataElementLeftList = [...list[i].dataElements]
				setState({ ...state, conditionsUIList: conditionData });
				break;
			} else {
				conditionData[index].dataModelLeftSelected = "";
				conditionData[index].dataElementLeftList = []
				setState({ ...state, conditionsUIList: conditionData });
			}
		}
	};

	const handleElementsLeftChange = (event, index) => {
		let conditionData = state.conditionsUIList;
		conditionData[index].dataElementLeftSelected = event.target.value;
		for (let i = 0; i < conditionData[index].dataElementLeftList.length; i++) {
			if (conditionData[index].dataElementLeftList[i].name === event.target.value) {
				conditionData[index].dataElementType = conditionData[index].dataElementLeftList[i].dataElementType;
				break;
			} else {
				conditionData[index].dataElementType = "";
			}
		}
		setState({ ...state, conditionsUIList: conditionData });
	}

	const handleOperatorChange = (event, index) => {
		let conditionData = state.conditionsUIList;
		conditionData[index].operatorSelected = event.target.value;
		setState({ ...state, conditionsUIList: conditionData });
	}

	const handleCompartorChange = (event, index) => {
		let conditionData = state.conditionsUIList;
		conditionData[index].selectedComparator = event.target.value;
		setState({ ...state, conditionsUIList: conditionData });
	}

	const handleInpuFieldChange = (data, index) => {
		let conditionData = state.conditionsUIList;
		conditionData[index].inputField = data.target.value;
		setState({ ...state, conditionsUIList: conditionData });
	}

	const handleDataModelRightChange = (event, index) => {
		let list = props.dataModels?.data
		let conditionData = state.conditionsUIList;
		for (let i = 0; i < list.length; i++) {
			if (list[i]._id === event.target.value) {
				conditionData[index].dataModelRightSelected = event.target.value;
				conditionData[index].dataElementRightList = [...list[i].dataElements]
				setState({ ...state, conditionsUIList: conditionData });
				break;
			} else {
				conditionData[index].dataModelRightSelected = "";
				conditionData[index].dataElementRightList = [];
				setState({ ...state, conditionsUIList: conditionData });
			}
		}
	};

	const handleElementsRightChange = (event, index) => {
		let conditionData = state.conditionsUIList;
		conditionData[index].dataElementRightSelected = event.target.value;
		setState({ ...state, conditionsUIList: conditionData });
	}

	const handleActionTypeChange = (event, index) => {
		let actionsData = state.actionsUIList;
		actionsData[index].actionTypeSelected = event.target.value;
		setState({ ...state, actionsUIList: actionsData });
	}

	const handleDataModelActionChange = (event, index) => {
		let list = props.dataModels?.data
		let actionsData = state.actionsUIList;
		for (let i = 0; i < list.length; i++) {
			if (list[i]._id === event.target.value) {
				actionsData[index].dataModelSelected = event.target.value;
				actionsData[index].dataElementList = [...list[i].dataElements];
				actionsData[index].dataElementMultiList = list[i].dataElements.map((item) => ({ label: item.name, value: item.name }));
				actionsData[index].dataElementMultiSelected = [];
				setState({ ...state, actionsUIList: actionsData });
				break;
			} else {
				actionsData[index].dataModelSelected = "";
				actionsData[index].dataElementList = [];
				actionsData[index].dataElementMultiList = [];
				actionsData[index].dataElementMultiSelected = [];
				setState({ ...state, actionsUIList: actionsData });
			}
		}
	};

	const handleElementsActionChange = (event, index) => {
		let actionsData = state.actionsUIList;
		actionsData[index].dataElementSelected = event.target.value;
		setState({ ...state, actionsUIList: actionsData });
	}

	const handleMultipleDataChange = (data, index) => {
		let actionsData = state.actionsUIList;
		actionsData[index].dataElementMultiSelected = data.target.value;
		setState({ ...state, actionsUIList: actionsData })
	}

	const handleSetValueChange = (data, index) => {
		let actionsData = state.actionsUIList;
		actionsData[index].setValue = data.target.value;
		setState({ ...state, actionsUIList: actionsData });
	}

	const handleDataValueChange = (data, index) => {
		let actionsData = state.actionsUIList;
		actionsData[index].dataValue = data.target.value;
		setState({ ...state, actionsUIList: actionsData })
	}

	const addConditions = () => {
		let conditions = conditionObj()
		console.log("conditions====", conditions);
		setState({ ...state, conditionsUIList: [conditions, ...state.conditionsUIList] });
	}

	const addActions = () => {
		setState({ ...state, actionsUIList: [actionObj(), ...state.actionsUIList] });
	}

	const removeConditions = (index) => {
		let list = state.conditionsUIList;
		list.splice(index, 1);
		setState({ ...state, conditionsUIList: list }, () => console.log(state.conditionsUIList));
	}

	const removeActions = (index) => {
		let list = state.actionsUIList;
		list.splice(index, 1);
		setState({ ...state, actionsUIList: list }, () => console.log(state.actionsUIList));
	}
	const executeRule = () => {
		if (state.form._id)
			props.executeRule(state.form._id, props.match.params.appid);
		else
			alert("please save the businessRule")
	}
	const saveDetails = (isNew) => {
		console.log("state.conditionsUIList====", state.conditionsUIList);
		console.log("state.actionsUIList====", state.actionsUIList);
		let data = state.form;
		data.description = "";
		data.ruleset = [];
		data.ruleset.push({ "rule_definition": {} });
		data.ruleset[0].rule_definition.conditions = constructConditionsData(state.conditionsUIList, props.dataModels);
		console.log("data.ruleset[0].rule_definition.conditions====", data.ruleset[0].rule_definition.conditions);
		data.ruleset[0].rule_definition.actions = constructActionsData(state.actionsUIList, props.dataModels);
		data.appId = props.match.params.appid
		if (isNew) {
			props.saveBusinessRule(data);
		} else {
			props.updateBusinessRule(data);
		}
	}

	const handleChangeTree = (treeData) => {
		setState({ ...state, form: { ...state.form, queryBuilder: treeData } });
	}

	const handleQueryDatamodelChange = (event) => {
		setState({ ...state, form: { ...state.form, queryDatamodel: event.target.value } });
	}

	return (
		<View
			{...props}
			state={state}
			handleChange={handleChange}
			handleChipChange={handleChipChange}
			canBeSubmitted={canBeSubmitted}
			saveBusinessRule={() => saveBusinessRuleData()}
			updateBusinessRule={() => updateBusinessRuleData()}
			handleDataModelLeftChange={handleDataModelLeftChange}
			handleElementsLeftChange={handleElementsLeftChange}
			handleOperatorChange={handleOperatorChange}
			handleCompartorChange={handleCompartorChange}
			handleDataModelRightChange={handleDataModelRightChange}
			handleElementsRightChange={handleElementsRightChange}
			handleInpuFieldChange={handleInpuFieldChange}
			handleDataModelActionChange={handleDataModelActionChange}
			handleElementsActionChange={handleElementsActionChange}
			handleMultipleDataChange={handleMultipleDataChange}
			handleSetValueChange={handleSetValueChange}
			handleDataValueChange={handleDataValueChange}
			handleActionTypeChange={handleActionTypeChange}
			handleChangeTree={handleChangeTree}
			handleQueryDatamodelChange={handleQueryDatamodelChange}
			removeConditions={removeConditions}
			addConditions={addConditions}
			removeActions={removeActions}
			addActions={addActions}
			selectedComparatorList={selectedComparatorList}
			actionTypesList={actionTypesList}
			dataTypeNumList={dataTypeNumList}
			dataTypeStringList={dataTypeStringList}
			saveDetails={saveDetails}
			executeRule={executeRule}
		/>
	)
}

export default withRouter(Redux(Container))